const prefix = 'new-instance-dialog';

export const i18n = {
    title: {
        id: `${prefix}.title`,
        defaultMessage: 'New Instance',
    },
    displayName: {
        id: `${prefix}.displayName`,
        defaultMessage: 'Display Name',
    },
    accountName: {
        id: `${prefix}.accountName`,
        defaultMessage: 'Account Name',
    },
    legalName: {
        id: `${prefix}.legalName`,
        defaultMessage: 'Legal Name',
    },
    salesforceId: {
        id: `${prefix}.salesforceId`,
        defaultMessage: 'Salesforce ID',
    },
    capacityGroupName: {
        id: `${prefix}.capacityGroupName`,
        defaultMessage: 'Capacity Group Name',
    },
    capacityGroupId: {
        id: `${prefix}.capacityGroupId`,
        defaultMessage: 'Capacity Group ID',
    },
    comment: {
        id: `${prefix}.comment`,
        defaultMessage: 'Comments',
    },
    cancel: {
        id: `${prefix}.cancel`,
        defaultMessage: 'Cancel',
    },
    create: {
        id: `${prefix}.create`,
        defaultMessage: 'Create',
    },
    createSuccess: {
        id: `${prefix}.createSuccess`,
        defaultMessage: 'Instance created',
    },
    createError: {
        id: `${prefix}.createError`,
        defaultMessage: 'Failed to create instance',
    },
    displayNameRequired: {
        id: `${prefix}.displayNameRequired`,
        defaultMessage: 'Display Name is required',
    },
    capacityGroupIdInvalid: {
        id: `${prefix}.capacityGroupIdInvalid`,
        defaultMessage: 'Must be a valid UUID',
    },
    defaultStoresError: {
        id: `${prefix}.defaultStoresError`,
        defaultMessage: 'Could not load the default tenant stores. Refresh the page to try again.',
    },
} as const;
